import React, { useEffect, useState } from "react";
import "./SPiServices.css";
import { fetchData } from "../../components/api";
import Banner from "../Banner/Banner";

const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;

const SPiServices = () => {
  const [spIServices, setSPiServices] = useState("");
  const [loading, setloading] = useState(false)

  useEffect(() => {
    const apiUrl = `${SALONAPI}/customWebsiteInfo`;

    fetchData(apiUrl).then((data) => {
        setSPiServices(data.website_settings.sp_iservices && (data.website_settings.sp_iservices || ''));
        setloading(true)
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [spIServices]);

  return (
    <div>
      <Banner />

      {
        loading ? (<div className="tenant-access-section " dangerouslySetInnerHTML={{ __html: spIServices }}></div>) : (
          <section style={{paddingTop:'83px'}}>
             <div className="container">
               <div className="shimmer" style={{minHeight:'25px',display:'block',width:'200px',borderRadius:'5px',marginBottom:'20px  '}}></div>

               <div className="row" style={{marginBottom:'40px'}}>
                 <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
                   <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
                 </div>

                 <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
                   <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
                 </div>

               </div>

               <div className="row" style={{marginBottom:'40px'}}>
                 <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
                   <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
                 </div>

                 <div className="wg-half" style={{width:'100%',marginRight:'20px'}}>
                   <div className="shimmer" style={{minHeight:'25px',display:'block',marginBottom:'20px',borderRadius:'5px',width:'400px'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'100%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'95%'}}></div>

                   <div className="shimmer" style={{minHeight:'18px',display:'block',marginBottom:'16px',borderRadius:'5px',width:'90%'}}></div>
                 </div>
                 
               </div>

             
             </div>
          </section>
        )
      }
    
    </div>
  );
};

export default SPiServices;
